import { render, staticRenderFns } from "./Socio.vue?vue&type=template&id=2701617e&scoped=true&"
import script from "./Socio.vue?vue&type=script&lang=js&"
export * from "./Socio.vue?vue&type=script&lang=js&"
import style0 from "./Socio.vue?vue&type=style&index=0&id=2701617e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2701617e",
  null
  
)

component.options.__file = "Socio.vue"
export default component.exports